import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="mx-auto flex min-h-[60vh] max-w-[900px] flex-col items-center justify-center px-4 py-20 text-center md:px-6">
      <div className="mb-6 flex items-center gap-2">
        <span className="flex h-6 w-6 items-center justify-center rounded-sm bg-primary-600 text-[10px] font-bold text-background-50">
          18+
        </span>
        <span className="text-[11px] tracking-[0.2em] text-foreground-500">PAGE NOT FOUND</span>
      </div>
      <p className="font-heading text-[64px] leading-none text-primary-700 md:text-[96px]">404</p>
      <h1 className="mt-4 font-heading text-xl text-foreground-950 md:text-2xl">这个页面不在档案里</h1>
      <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-600">
        你访问的地址
        <span className="mx-1 break-all rounded-sm bg-background-100 px-1.5 py-0.5 text-[12px] text-foreground-700">
          {location.pathname}
        </span>
        没有对应的内容，可能已被移除或链接有误。
      </p>
      <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="cursor-pointer whitespace-nowrap rounded-md bg-primary-600 px-5 py-2.5 text-sm font-medium text-background-50 transition hover:bg-primary-700"
        >
          返回首页
        </Link>
        <Link
          to="/news"
          className="cursor-pointer whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-medium text-foreground-700 transition hover:border-primary-300 hover:text-primary-700"
        >
          浏览资讯
        </Link>
        <Link
          to="/resources"
          className="cursor-pointer whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-medium text-foreground-700 transition hover:border-primary-300 hover:text-primary-700"
        >
          查看资源库
        </Link>
      </div>
    </div>
  );
}